import { Doc, generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { GoogleSheetsIntegrationConfig } from '@dadohr/shared/domainTypes/integrations/googleSheets';
import { FS } from '@dadohr/shared/versions';
import {
  store,
  useMappedLoadingValue
} from '../../../../../../services/firebase';
import {
  callFirebaseFunction,
  useFirebaseFunction
} from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';
import { now } from '../../../../../../services/time';

export const toGoogleSheetsConfigDoc = generateToDocFn<GoogleSheetsIntegrationConfig>();

const COLLECTION = FS.googleSheetsIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const googleSheetsConfigStore = createDocumentListenerGetter(
  (orgId) => collection().doc(orgId),
  toGoogleSheetsConfigDoc
);

export const useGoogleSheetsConfig = (orgId: string, userId: string) => {
  return useMappedLoadingValue(
    useDocumentListener(googleSheetsConfigStore(orgId)),
    (d) => {
      if (!d) {
        const n = now();
        const newConfig: Doc<GoogleSheetsIntegrationConfig> = {
          id: orgId,
          collection: COLLECTION,
          data: {
            orgId,
            active: false,
            createdAt: n,
            createdBy: userId,
            editedAt: n,
            editedBy: userId,

            accessToken: '',
            refreshToken: '',
            scope: '',
            expiryDate: 0
          }
        };
        return newConfig;
      }
      return d;
    }
  );
};

const toUrl = (fnName: string) => `integrations_googleSheets-${fnName}`;

export type GoogleCurrentUser = {
  aud: string;
  user_id?: string;
  scopes: string[];
  expiry_date: number;
  sub?: string;
  azp?: string;
  access_type?: string;
  email?: string;
  email_verified?: boolean;
};

export const useGoogleSheetsCurrentUser = (orgId: string) => {
  return useFirebaseFunction<GoogleCurrentUser>(
    toUrl('currentUser'),
    { orgId },
    [orgId]
  );
};

export const getGoogleSheetsCurrentUser = (orgId: string) =>
  callFirebaseFunction<GoogleCurrentUser>(toUrl('currentUser'), { orgId });

export const removeGoogleSheetsConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
